module.exports = __webpack_public_path__ + "img/justdial.6d346985.png";